/** The HTTP status of an error: `status` (fetch wrappers) or `response.status` (axios). */
export function errorStatus(error: unknown): number {
    if (typeof error !== 'object' || error === null) return NaN;
    if ('status' in error) return Number((error as { status: unknown }).status);
    const response = (error as { response?: { status?: unknown } }).response;
    return response ? Number(response.status) : NaN;
}

/** Toast title for a failed call, from the HTTP status the API answered with (a 403 reads "Not allowed"). */
export function errorTitle(error: unknown): string {
    const status = errorStatus(error);
    if (status === 403) return 'Not allowed';
    if (status === 409) return 'Conflict';
    if (status === 400) return 'Not valid';
    if (status === 404) return 'Not found';
    if (status === 401) return 'Signed out';
    return 'Something went wrong';
}

/**
 * The message of an error for a toast or an inline error: the API's `message` / text body (axios `response.data`), else
 * the error's own message.
 */
export function describeError(error: unknown): string {
    if (typeof error === 'string') return error;
    if (typeof error !== 'object' || error === null) return String(error);
    const data = (error as { response?: { data?: unknown } }).response?.data;
    if (typeof data === 'string' && data.trim() !== '') return data;
    if (data && typeof data === 'object') {
        const record = data as { message?: unknown; title?: unknown; detail?: unknown };
        for (const value of [record.message, record.detail, record.title]) {
            if (typeof value === 'string' && value.trim() !== '') return value;
        }
    }
    if (error instanceof Error && error.message) return error.message;
    const message = (error as { message?: unknown }).message;
    return typeof message === 'string' ? message : 'The request failed.';
}
